<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-配送设置-添加
    -->
    <el-dialog
    title="添加配送设置"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
 
      <el-form-item label="配送设置名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入配送设置名称" class="max-w460"></el-input>
          </el-form-item>

      <el-form-item label="配送司机" prop="u">
                 
        <el-button @click="openGetuser('driver')" icon="el-icon-plus">选择司机</el-button>
          <div>  姓名：{{ user.nickName?user.nickName:"还未选择" }}</div>

      </el-form-item>  

      <el-form-item label="司机每单/元" prop="driver_order" >
            <el-input v-model="form.driver_order" placeholder="请输入司机每单/元" 
            style="width: 200px;"
            class="max-w460"></el-input>
          </el-form-item>

      <el-form-item label="最低起送金额" prop="min_delivery_price" >
            <el-input v-model="form.min_delivery_price" placeholder="请输入最低起送金额" 
            style="width: 200px;"
            class="max-w460"></el-input>
          </el-form-item>

          <el-form-item label="配送时间段设置" >
        <el-button size="small" type="primary" @click="addSetting" >新增配送时间段设置</el-button>
        <el-table :data="form.setting"  border size="mini" style="width: 100%;margin-top: 20px;">
   

            <el-table-column prop="name" label="标签名称"   width="200" >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-select id="searchType" v-model="scope.row.dates" class="searchType">
                      <el-option  label="周一" value="1"></el-option>
                      <el-option  label="周二" value="2"></el-option>
                      <el-option  label="周三" value="3"></el-option>
                      <el-option  label="周四" value="4"></el-option>
                      <el-option  label="周五" value="5"></el-option>
                      <el-option  label="周六" value="6"></el-option>
                      <el-option  label="周日" value="7"></el-option>     
                  </el-select>
                </div>
              </template>
            </el-table-column>    
            
            <el-table-column prop="name" label="选择开始时间"   width="200" >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-time-picker
                      v-model="scope.row.times_one"
                      start-placeholder="时间"
                      placeholder="选择开始时间"
                      format="HH:mm"
                      value-format="HH:mm"
                      >
                    </el-time-picker>
                </div>
              </template>
            </el-table-column> 


            <el-table-column prop="name" label="选择结束时间"   width="200" >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-time-picker
                      v-model="scope.row.times_two"
                      start-placeholder="时间"
                      placeholder="选择结束时间"
                      format="HH:mm"
                      value-format="HH:mm"
                      >
                    </el-time-picker>
                </div>
              </template>
            </el-table-column> 



            <el-table-column prop="name" label="操作"  width="100">
              <template v-slot="scope">
                <div style="color: blue;" @click="delSetting(scope.$index)">删除</div>

              </template>
            </el-table-column>
          </el-table>
      </el-form-item> 

 

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

    </div>

    <GetInsUser :is_open="open_cm" :code="code" :multi="multi"   @close="closeCm"></GetInsUser>

    <Dates :is_open="open_dates"  :multi="multidates"   @close="closeDates"></Dates>


</el-dialog>
  
</template>

<script>
import LineApi from '@/api/line.js';
import GetInsUser from '@/components/user/getInsUser.vue';
import Dates from '@/components/user/dates.vue';

export default {
  components: {
    GetInsUser,
    Dates
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
      /*form表单数据*/
      form: {
        user_id:0,
        name:"",
        time_period:"",
        min_delivery_price:"",
        first_order_delivery_price_free:"",
        first_order_delivery_price_no:"",
        other_order_delivery_price_free:"",
        other_order_delivery_price_no:"",
        delivery_date:[],
        store:[],
        is_default:0,
        setting:[],
        driver_order:0,

      },

      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入配送设置名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      open_cm:false,
        code:"",
        multi:false,
        user:{

      },
      multidates:true,
      open_dates:false,
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
    delSetting(index){
        this.form.setting.splice(index,1)
    },
      addSetting(){
        this.form.setting.push({
          dates:'',
          times_one:"",
          times_two:"",
          hospital_id:0
        });
      },

    openDates(code){
      this.open_dates = true;
    },
    closeDates(e){
      var self = this;
      self.open_dates=false;
      this.form.delivery_date = e.params
    },
    del(index){
      this.form.delivery_date.splice(index,1);
    },


    /*打开获取用户*/
    openGetuser(code) {
      this.open_cm = true;
      this.code = code;
    },
  
    closeCm(e){
      var self = this;
      self.open_cm=false;
      if(e.params && e.params.user_id){
   
        self.form.user_id = e.params.user_id;
        self.user.mobile = e.params.mobile;
        self.user.nickName = e.params.nickName;

      }


    },
   

     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          LineApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },

  }
};
</script>

<style>
.dates{
  height: 30px;line-height: 30px; background: #66B1FF;width: 60px;float: left;margin-right: 10px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  margin-top: 5px;

}
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/line/index/part/add.vue